import type { FaireProductEntity } from "../../entity_types/product";

export const p_s7m6d3zb8j: FaireProductEntity = {
  token: "p_s7m6d3zb8j",
  type: "product",
  name: "STORE INDYA Copper Water Bottle – 30 oz | 100% Pure Copper",
  brandToken: "b_zz3uf54cby",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ae98413ee767b9d3c5182110068d48f19375802829af398a3f91bcb04fa02700.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0dede6cb3ffe1b09ee2ed3954f7f0934dd067d3f0af409b290d6d28c982407ae.jpeg",
    "https://cdn.faire.com/fastly/46138197de15dda2d21f2f55cb7333b0388f2839eba77d222a23798749d3cedb.jpeg",
    "https://cdn.faire.com/fastly/6ef875ba3d577bd343d68abdabaa22ecdb975d0822035d991de96f4721857e14.jpeg",
    "https://cdn.faire.com/fastly/e1c9e243d21971a0c82e967f655ca2a1b99ed9638f6d0c50bb63228f9dfadba1.jpeg",
  ],
  priceDollars: 21.47,
  description:
    "Features:\n\n100% Pure Copper with Ayurvedic Benefits: Made from pure copper, traditionally known in Ayurveda to support digestion and overall wellness when water is stored overnight.\n\nLeak-Proof & Travel Friendly: Equipped with a secure lid and silicone ring to prevent spills, making it ideal for travel, gym sessions, office desks, and daily hydration.\n\nEco-Friendly & Easy to Maintain: A sustainable alternative to plastic bottles. Hand wash only and clean naturally with lemon and baking soda to maintain its shine and quality.\n\nStylish Hammered Finish: Elegant hammered texture provides a better grip and adds a sophisticated touch to your kitchen, workspace, or fitness routine.\n\nThoughtful Wellness Gift: A meaningful gift choice for yoga enthusiasts, fitness lovers, health-conscious friends, and special occasions.\n\nStay hydrated the natural way with a timeless copper bottle that blends health, elegance, and practicality.",
  tags: [],
  msrpDollars: 42.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:27.348Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
